export const MesCosechaArray =[
    {id:'01',display:'ENERO'},
    {id:'02',display:'FEBRERO'},
    {id:'03',display:'MARZO'},
    {id:'04',display:'ABRIL'},
    {id:'05',display:'MAYO'},
    {id:'06',display:'JUNIO'},
    {id:'07',display:'JULIO'},
    {id:'08',display:'AGOSTO'},
    {id:'09',display:'SEPTIEMBRE'},
    {id:'10',display:'OCTUBRE'},
    {id:'11',display:'NOVIEMBRE'},
    {id:'12',display:'DICIEMBRE'},
]